/** @jsxImportSource react */
import NewModal from '@react/shared/components/NewModal';
import { any, bool, func } from 'proptypes';
import clsxm from 'sly/lib/clsxm';

export default function ModalTray({ className, ...props }) {
  return (
    <NewModal
      className={clsxm(
        className,
        'fixed inset-0 mx-auto mt-auto !h-max max-h-[90%] min-w-full rounded-t-2xl border border-white p-0 md:m-auto  md:!max-h-[75%] md:w-full md:min-w-[unset] md:!max-w-2xl md:rounded-2xl lg:!max-w-5xl'
      )}
      {...props}
    />
  );
}

ModalTray.propTypes = {
  children: any,
  onClose: func,
  isOpen: bool,
  transparent: bool,
};
